// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"109":"1d4d479b","121":"e7e74509","528":"ad952c76","979":"7d1b3045"}[chunkId] + ".chunk.js";
};